import { literal, string, struct } from 'io-ts/lib/Decoder';

/**
 * Sent when the scale is updated.
 */
export const ScaleUpdated = struct({
	type: literal('scale-updated'),
	/** Human-readable scale e.g. "1:100" or "1/4" = 1'-0"" */
	textScale: string,
});
